import {
  Avatar,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  makeStyles,
  withWidth,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import FullScreenDialog from "../../../components/FormDialog/FormDialog";
import QRCode from "qrcode.react";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
  },
  headerPages: {
    fontWeight: 700,
    color: "#212121",
    fontSize: 16,
    marginTop: 15,
  },
  description: {
    fontSize: 12,
    color: "#757575",
  },
}));

function WidthdrawInfo(props) {
  const classes = useStyles();
  const { title, order, width, proceed } = props;
  const [openDialog, setOpenDialog] = React.useState(true);

  const handleCloseDialog = () => {
    setOpenDialog(false);
    proceed();
  };

  return (
    <div>
      <FullScreenDialog
        disableBackdropClick
        maxWidth="md"
        fullScreen={width === "xs"}
        title={props.title}
        HiddenCloseIcon
        scroll="body"
        open={openDialog}
      >
        <DialogContent style={{ padding: "24px", minWidth: 620 }}>
          <Grid container>
            <Grid item xs={12}>
              <Grid
                container
                direction="row"
                justify="flex-end"
                alignItems="flex-end"
              >
                {" "}
                <IconButton
                  onClick={() => {
                    handleCloseDialog();
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>

              <div className={classes.headerPages}>
                Informasi Penarikan Saldo
              </div>
              <div className={classes.headerPages}>Minimum Penarikan</div>
              <div className={classes.description}>
                BCA, BNI, BRI, Mandiri - Rp10.000
              </div>
              <div className={classes.description}>Bank Lain - Rp50.000</div>
              <div className={classes.headerPages}>Biaya Admin</div>
              <div className={classes.description}>BRI - Rp1.000</div>
              <div className={classes.description}>
                Biaya Transfer Antar Bank Ditanggung Pengguna
              </div>
              <div className={classes.headerPages}>Waktu Penarikan</div>
              <div className={classes.description}>
                BCA, BRI, BNI, CIMB, BNI Syariah, Mandiri - paling lama 24 jam
              </div>
              <div className={classes.description}>
                Bank Lain - paling lama 2 hari kerja (tidak termasuk
                Sabtu/Minggu/libur)
              </div>
            </Grid>
          </Grid>
        </DialogContent>
      </FullScreenDialog>
    </div>
  );
}

WidthdrawInfo.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};
export function showWidthdrawInfo(title, order, handleGetList, options = {}) {
  return createConfirmation(confirmable(withWidth()(WidthdrawInfo)))({
    title,
    order,
    handleGetList,
    ...options,
  });
}
